import {call, put, takeEvery} from "redux-saga/effects";
import {
    CREATE_POPAP_NOTIFICATION_REQUEST,
    CREATE_POPAP_NOTIFICATION_REQUEST_SUCCESS,
    GET_POPAP_STATUS_REQUEST,
    GET_POPAP_STATUS_REQUEST_SUCCESS,
    UPDATE_POPAP_STATUS_REQUEST
} from "./actionTypes";
import {notification} from 'antd';
import {GET_NEWS_REQUEST_SUCCESS} from "../news/actionTypes";

const modalSuccess = type => {
    notification[type]({
        message: 'წარმატება',
        description: 'ოპერაცია წარმატებით შესრულდა',
    });
};

const modalError = type => {
    notification[type]({
        message: 'შეცდომა',
        description: 'მოხდა შეცდომა მიმართეთ IT განყოფილებას',
    });
};



function* createPopapSaga({payload}) {
    try {
        const callBack = yield call(createPopapSagaAsync, payload)

        if (callBack.success){
            modalSuccess('success')
        }
    } catch (e) {
        console.error(e);
    }
}

const createPopapSagaAsync = async (item) => {
    let jwt = localStorage.getItem("token")
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api2/popap/create`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Authorization': `Bearer ${jwt}`,
        },
        body : JSON.stringify(item)
    })
    return await response.json()
}


function* updatePopapStatusSaga({payload}) {
    try {
        const callBack = yield call(updatePopapStatusSagaAsync, payload)
        if (callBack.success){
            modalSuccess('success')
        }
    } catch (e) {
        console.error(e);
    }
}

const updatePopapStatusSagaAsync = async (item) => {
    let jwt = localStorage.getItem("token")
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api2/popap/updateStatus`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Authorization': `Bearer ${jwt}`,
        },
        body : JSON.stringify(item)
    })
    return await response.json()
}


function* getPopapSaga({payload}) {
    try {
        const callBack = yield call(getPopapSagaAsync, payload)
        if (callBack.success){

            yield put({type: GET_POPAP_STATUS_REQUEST_SUCCESS, callBack})
        }
    } catch (e) {
        console.error(e);
    }
}

const getPopapSagaAsync = async (item) => {
    let jwt = localStorage.getItem("token")
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api2/popap/get`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Authorization': `Bearer ${jwt}`,
        }
    })
    return await response.json()
}



function* popapSaga() {
    yield takeEvery(CREATE_POPAP_NOTIFICATION_REQUEST, createPopapSaga)
    yield takeEvery(UPDATE_POPAP_STATUS_REQUEST, updatePopapStatusSaga)
    yield takeEvery(GET_POPAP_STATUS_REQUEST, getPopapSaga)
}

export default popapSaga
